import React, { useRef } from 'react';

import Card from 'bundles/apex/card/details';
import CustomFields from 'bundles/apex/deals/show/overview/values/custom_fields';
import { useHasChildren } from 'bundles/project/hooks';

const CustomFieldsCard = () => {
  const ref = useRef(null);
  const hasFields = useHasChildren(ref);

  return (
    <Card
      className={hasFields ? '' : 'hidden'}
      label="Custom Fields"
      tbodyRef={ref}
    >
      <CustomFields category={null} />
    </Card>
  );
};

export default CustomFieldsCard;
